[
  {
    "id": "urn:li:function:1",
    "label": "Accounting"
  },
  {
    "id": "urn:li:function:2",
    "label": "Administrative"
  },
  {
    "id": "urn:li:function:3",
    "label": "Arts and Design"
  },
  {
    "id": "urn:li:function:4",
    "label": "Business Development"
  },
  {
    "id": "urn:li:function:5",
    "label": "Community and Social Services"
  },
  {
    "id": "urn:li:function:6",
    "label": "Consulting"
  },
  {
    "id": "urn:li:function:7",
    "label": "Education"
  },
  {
    "id": "urn:li:function:8",
    "label": "Engineering"
  },
  {
    "id": "urn:li:function:9",
    "label": "Entrepreneurship"
  },
  {
    "id": "urn:li:function:10",
    "label": "Finance"
  },
  {
    "id": "urn:li:function:11",
    "label": "Healthcare Services"
  },
  {
    "id": "urn:li:function:12",
    "label": "Human Resources"
  },
  {
    "id": "urn:li:function:13",
    "label": "Information Technology"
  },
  {
    "id": "urn:li:function:14",
    "label": "Legal"
  },
  {
    "id": "urn:li:function:15",
    "label": "Marketing"
  },
  {
    "id": "urn:li:function:16",
    "label": "Media and Communication"
  },
  {
    "id": "urn:li:function:17",
    "label": "Military and Protective Services"
  },
  {
    "id": "urn:li:function:18",
    "label": "Operations"
  },
  {
    "id": "urn:li:function:19",
    "label": "Product Management"
  },
  {
    "id": "urn:li:function:20",
    "label": "Program and Project Management"
  },
  {
    "id": "urn:li:function:21",
    "label": "Purchasing"
  },
  {
    "id": "urn:li:function:22",
    "label": "Quality Assurance"
  },
  {
    "id": "urn:li:function:23",
    "label": "Real Estate"
  },
  {
    "id": "urn:li:function:24",
    "label": "Research"
  },
  {
    "id": "urn:li:function:25",
    "label": "Sales"
  },
  {
    "id": "urn:li:function:26",
    "label": "Customer Success and Support"
  }
]
